import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { RefreshMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'

/** Matches the hairline treatment the other table toolbars apply to their white buttons. */
const headerButtonCss = tw`border border-solid border-shades-100 hover:border-shades-200 active:border-shades-200`

interface Props {
  onRefresh(): void
}

/**
 * No search field, unlike the markets and catalog toolbars. The list is server-paginated and
 * the endpoint takes no search parameter, so filtering the page in hand would silently hide
 * matches sitting on other pages.
 */
const ComposedInvoicesTableToolbarComponent = ({ onRefresh }: Props) => {
  return (
    <div
      css={tw`flex flex-row items-center gap-4 rounded-t-lg border-0 border-b border-t border-solid border-shades-100 bg-white px-4 py-3`}
    >
      <Typography variant="body2" css={tw`text-shades-500`}>
        Newest first. Historical invoices are not listed.
      </Typography>
      <div css={tw`ml-auto`}>
        <Button
          size="small"
          color="white"
          className={headerButtonCss}
          leftIcon={<RefreshMinor width={20} />}
          onClick={onRefresh}
          data-testid="invoices-list-refresh-button"
        >
          Refresh
        </Button>
      </div>
    </div>
  )
}

export const ComposedInvoicesTableToolbar = memo(ComposedInvoicesTableToolbarComponent)
